































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
// import ModelFactory from "@/model/ModelFactory";
import StatusModel from "@/model/Status";
// import ReportApi from "@/api/Report";

import InputControl from "@/components/Controls/InputControl.vue";
import { BoolType, ValueOrNone, BoolClass } from "@/helpers/Table";

const ReportType = (type: string): string => {
  switch (type) {
    case "draft":
      return "Kopia robocza";
    case "edit":
      return "W edycji";
    case "current":
      return "Zapisany";
  }
  return "";
};

@Component({
  name: "AdminStatus",
  components: {
    InputControl
  }
})
export default class AdminStatus extends Vue {
  @Prop()
  public value!: StatusModel;

  public statusFilter: string = "";
  public fields: Array<BTableFieldDefinition> = [
    {
      key: "organizationName",
      label: "Organizacja",
      formatter: (value: string) => value,
      sortable: true
    },
    {
      key: "hasPreliminaryReport",
      label: "Raport wstępny",
      formatter: (value: any) => BoolType(value),
      tdClass: (value: any) =>
        `table-status__has-preliminary-report ${BoolClass(value)}`,
      sortable: true
    },
    {
      key: "hasReport",
      label: "Raport roczny",
      formatter: (value: any) => BoolType(value),
      tdClass: (value: any) => `table-status__has-report ${BoolClass(value)}`,
      sortable: true
    },
    {
      key: "reportType",
      label: "Staus",
      formatter: (value: any) => ReportType(value),
      tdClass: () => `table-status__report-type`
    },
    {
      key: "hasReportUrl",
      label: "Link do Raportu",

      tdClass: (value: any) => `table-status__report-url ${BoolClass(value)}`,
      sortable: true
    },
    {
      key: "hasOrganizationReportUrl",
      label: "Link do Raportu Organizacji",
      tdClass: (value: any) => `table-status__report-url ${BoolClass(value)}`,
      sortable: true
    },
    {
      key: "hasOrganizationList",
      label: "Lista organizacji",
      formatter: (value: any) => ValueOrNone(value),
      tdClass: (value: any) =>
        `table-status__has-organization-list ${BoolClass(value)}`,
      sortable: true
    }
  ];

  // @Watch('value')
  // setValue(newValue)
}
